import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.2.1_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.63.0_react-d_fcbb7cadd7d5557f34098bd2b4848157/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-loading-skeleton@3.5.0_react@19.2.4/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/overrides/@maestro.commerce-blocks/components/add-to-cart-button/add-to-cart-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/overrides/@maestro.commerce-blocks/components/product-card/product-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/article-teaser/article-teaser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/banner/banner-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/banner/banner-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/image-product/image-product.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqStructuredData"] */ "/app/packages/commerce-blocks/components/metadata/faq-metadata.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/not-found/not-found.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-card/product-card-wishlist-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-labels/product-labels.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-simple-list/product-simple-list-skeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-simple-list/product-simple-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-slider/lazy-product-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/product-slider/product-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/commerce-blocks/components/reviews/stars.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTypeProvider"] */ "/app/packages/commerce-blocks/providers/page-type-provider/page-type-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductListingReviewsProvider","useProductListingReviewsContext"] */ "/app/packages/commerce-blocks/providers/product-listing-reviews/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/cookiebot-cookie-consent/components/cookiebot-consent-gate/cookiebot-consent-gate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookiebotScriptAgentValidator"] */ "/app/packages/cookiebot-cookie-consent/components/cookiebot-script/cookiebot-script-agent-validator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/cookiebot-cookie-consent/components/cookiebot-trigger/cookiebot-trigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookiebotEventPublisher"] */ "/app/packages/cookiebot-cookie-consent/providers/cookiebot-event-publisher.ts");
;
import(/* webpackMode: "eager", webpackExports: ["EventPublish"] */ "/app/packages/core/event/components/event-publish.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/sanity-cms-blocks/blocks/cms-ball-links/cms-ball-link-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/sanity-cms-blocks/blocks/cms-buttons/cms-button/cms-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/sanity-cms-blocks/blocks/cms-links/cms-link.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity/components/cms/cms-page-preview.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/sanity/components/preview-provider/preview-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/accordion/accordion-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/accordion/accordion-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/accordion/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/button/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/button/filter-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/button/label-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/button/swatch-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/carousel/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/embedded-script/embedded-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/embedded-video/embedded-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/icon/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/link/link.tsx");
